import React from 'react';
import './AppArticle.css';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

class AppArticle extends React.Component {
  constructor(props) {
    super(props);
    
    // 初始化状态
    this.state = {
      title: '',
      markdown: '',
      meta: {
        update_time: '',
        tags: ''
      },
      loading: true,
      error: null
    };
  }

  async componentDidMount() {
    try {
      const { pid } = this.props;
      
      if (!pid) {
        throw new Error('No pid provided');
      }

      // 首先从index.json获取文章元数据
      const indexResponse = await fetch('https://www.opstool.com/index.json');
      if (!indexResponse.ok) {
        throw new Error(`Failed to fetch index: ${indexResponse.statusText}`);
      }
      
      const indexData = await indexResponse.json();
      const articleMeta = indexData.find(item => item.pid === pid);
      
      if (!articleMeta) {
        throw new Error('Article not found in index');
      }

      // 构建markdown文件URL
      const markdownUrl = `https://www.opstool.com/mds/${pid}.md`;
      
      // 获取markdown内容
      const response = await fetch(markdownUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch markdown: ${response.statusText}`);
      }
      
      const markdownText = await response.text();
      
      this.setState({
        title: articleMeta.title || '',
        markdown: markdownText.trim(),
        meta: {
          update_time: articleMeta.update_time || '',
          tags: articleMeta.tags || ''
        },
        loading: false
      });
    } catch (error) {
      console.error('Error loading article:', error);
      this.setState({
        error: error.message,
        loading: false
      });
    }
  }

  getMarkdownText() {
    const { markdown } = this.state;
    if (!markdown) return { __html: '' };
    
    // 使用 DOMPurify 净化 HTML
    const rawMarkup = marked(markdown);
    const cleanMarkup = DOMPurify.sanitize(rawMarkup);
    return { __html: cleanMarkup };
  }

  renderMetaInfo() {
    const { meta } = this.state;
    
    return (
      <p id='article_meta_info'>
        <img height='14' width='14' alt='日历图标' src='https://www.opstool.com/static/img/date.png'/>
        <span>{meta.update_time}</span>
        <span style={{ marginRight: '10px' }}></span>
        <img height='14' width='14' alt='标签图标' src='https://www.opstool.com/static/img/tag.png'/>
        <span>{meta.tags}</span>
      </p>
    );
  }

  render() {
    const { title, loading, error } = this.state;
    
    if (loading) {
      return <div>Loading...</div>;
    }
    
    if (error) {
      return <div>Error: {error}</div>;
    }
    
    return (
      <div id='article_view'>
        <div id='article_meta'>
          <h2 id='article_title'>{title}</h2>
          {this.renderMetaInfo()}
        </div>
        <div id='article_content' dangerouslySetInnerHTML={this.getMarkdownText()} />
      </div>
    );
  }
}

export default AppArticle;